export default __webpack_public_path__ + "static/media/preview-desktop-icon.03c483fc.svg";